import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core";
import Row from "react-bootstrap/Row";
import { API } from "../../../../Services/api-services";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import ErrorIcon from "@material-ui/icons/Error";
import Button from "@material-ui/core/Button";
import Loader from "../../../../Core/Loader/Loader";
import AddStudentAssessment from "./AddStudentAssessment";

const useStyles = makeStyles({
  header_div: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  header_div_update_assessment: {
    fontWeight: "bold",
    textDecoration: "underline",
    cursor: "pointer",
  },
  table_div: {
    width: "100%",
    marginTop: "5px",
  },
  tableContainer: {
    maxHeight: "calc(100vh - 240px)",
    overflow: "auto",
  },
});

const StudentAssessment = ({ studentId, batchId, toggleView }) => {
  const classes = useStyles();
  const [studentName, setStudentName] = useState("");
  const [data, setData] = useState([]);
  const [assessmentObj, setAssessmentObj] = useState({});
  const [loader, setLoader] = useState(true);
  const [addScoreModal, setAddScoreModal] = useState(false);
  const [assessmentCatalog, setAssessmentCatalog] = useState([]);

  useEffect(() => {
    getAssessmentScore(batchId, studentId);
  }, [studentId, batchId]);

  const getAssessmentScore = (batchId, studentId) => {
    setLoader(true);
    API.post("/get/Assment/CatlogDetails", { studentId, batchId })
      .then((res) => {
        setLoader(false);
        setAssessmentCatalog(res.data.response.assmentCatalog);
        setData(res.data.response.studentAssment);
        setStudentName(res.data.response.studentName);
      })
      .catch((e) => {
        console.error("Error while fetching catalog details", e);
      });
  };

  const addScore = () => {
    setAddScoreModal(true);
  };

  const editScore = (assessment) => {
    setAssessmentObj(assessment);
    setAddScoreModal(true);
  };

  const closeModalHandler = (hitApi) => {
    if (hitApi) {
      getAssessmentScore(batchId, studentId);
      setAddScoreModal(false);
      setAssessmentObj({});
    } else {
      setAssessmentObj({});
      setAddScoreModal(false);
    }
  };

  return (
    <Row>
      <div className={classes.header_div}>
        <div>
          <p>
            Student Name: <strong>{studentName}</strong>
          </p>
        </div>
        {/* <div
          onClick={() => toggleView("aoc")}
          className={classes.header_div_update_assessment}
        >
          <p>Update Daily Evaluation Score</p>
        </div> */}
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "1rem",
        }}
      >
        <Button color="primary" variant="contained" onClick={addScore}>
          Add Score
        </Button>
      </div>
      {/* <div style={{ color: "grey", marginTop: "5px" }}>
        <p>Displaying Test Scores for {totalClasses} classes</p>
      </div> */}
      {addScoreModal && (
        <AddStudentAssessment
          show={addScoreModal}
          closeModalHandler={closeModalHandler}
          batchId={batchId}
          studentId={studentId}
          assessmentDetails={assessmentObj}
          assessmentCatalog={assessmentCatalog}
          sequence={data.length + 1}
        />
      )}
      <div className={classes.table_div}>
        {loader ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "calc(100vh - 308px)",
            }}
          >
            <Loader />
          </div>
        ) : (
          <TableContainer className={classes.tableContainer}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">Date</TableCell>
                  <TableCell align="center">Number</TableCell>
                  <TableCell align="center">Description</TableCell>
                  <TableCell align="center">Score</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((score, index) => (
                  <TableRow>
                    <TableCell align="center">
                      {new Date(score.assmntDate).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })}
                      {score.assmntScore === null ||
                      score.assmntScore === "" ? (
                        <ErrorIcon style={{ color: "red" }} />
                      ) : (
                        <></>
                      )}
                    </TableCell>
                    <TableCell align="center">{score.assmntSequence}</TableCell>
                    <TableCell align="center">
                      {score["assessmentCatalog.description"]}
                    </TableCell>
                    <TableCell align="center">{score.assmntScore}</TableCell>
                    <TableCell>
                      <IconButton onClick={() => editScore(score, index)}>
                        <EditIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </div>
    </Row>
  );
};

export default StudentAssessment;
